import { useSyncExternalStore } from "react";
import {
  getOpenedClients,
  subscribeToOpenedClients,
} from "../openedClients";

/**
 * The client and form ids this browser has already seen, as a set to test a
 * row against — anything not in it is news, and wears a flag.
 *
 * Subscribed rather than read once: opening a client in this sitting has to
 * take the flag off the list behind it and one off the rail's count, and both
 * are drawn from the same store. See `openedClients`.
 */
export function useOpenedClients(): ReadonlySet<string> {
  return useSyncExternalStore(
    subscribeToOpenedClients,
    getOpenedClients,
    getOpenedClients
  );
}

export default useOpenedClients;
